<template>
    <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.3458 11.1729C23.3458 6.11527 19.2305 2 14.1729 2C9.11527 2 5 6.11527 5 11.1729C5 16.2305 9.11527 20.3458 14.1729 20.3458C16.3948 20.3458 18.4265 19.5504 20.0173 18.2363L27.781 26L29 24.781L21.2363 17.0173C22.5504 15.4265 23.3458 13.3948 23.3458 11.1729ZM14.1729 18.6167C10.0663 18.6167 6.72911 15.2795 6.72911 11.1729C6.72911 7.06628 10.0663 3.72911 14.1729 3.72911C18.2795 3.72911 21.6167 7.06628 21.6167 11.1729C21.6167 15.2795 18.2795 18.6167 14.1729 18.6167Z" :fill="color"/>    
    </svg>

</template>

<script setup>
defineProps({
    color: {
        type: String,
        required: false,
        default: '#1C1C1C'
    }
});

</script>
